import React from 'react';
import { SOURCE_DATA_TYPE, IData, ISourceInfo } from '../interface';
import { isLang, lang } from '@umu/ukit-lang';
import { Button, RadioItem, Tooltip, Checkbox, SnackBar } from '@umu/umu-design';
import { CustomImg } from '../images';
import { SESSION_TYPE_NAMES } from 'common/src/config';
import { If } from 'common/src/components';
import { Icon } from '../components/icon';
import { customFormatDateTime } from '@umu/umu-util';
import { openWindow } from '@umu/umu-dom';
import {
    getCourseList,
    getProgramList,
    getSessionList,
    getLecturerList,
    getMicroPagesList,
    getPracticeChannelList,
    getCanRelationPracticeList,
} from '../server';
import { getSessionIconClass } from '../utils';
import { UserAvatar } from '../../user';
import { FixedDirection, TextAlign } from 'common/src/components/customTable';
import { PermissionList } from '../components/permissionList';
import Loading from 'common/src/components/loading/loading';
import { practiceTypeName } from '../../../@utils/use';
import { PRACTICE_TYPE } from '@umu/umu-types';

type IAccessPermission = {
    [propName in string]: string;
};

const TABLE_ID = 'choose-content-table';

const accessPermissionMap: IAccessPermission = {
    '2': lang('企业内公开'),
    '1': lang('公开'),
    '3': lang('指定账户'),
    '0': lang('关闭'),
};

const getOperateWidth = () => {
    if (isLang('EN')) {
        return '120px';
    }
    if (isLang('ES') || isLang('JP')) {
        return '130px';
    }
    return '100px';
};
const getBlank = (total: number, isLoad: boolean, isKnowledge: boolean, extraPrams: Record<string, any>) => {
    const { isPracticeChannel } = extraPrams;
    const isEmpty = total === 0;
    const EmptyData = (
        <div className="empty-source">
            <Icon imgSrc={CustomImg.EmptySource} className="icon-empty-source-img" />
            <div className="empty-source-text">
                <p>{lang('暂无搜索结果')}</p>
                <If condition={isKnowledge}>
                    <p>{lang('仅支持搜索知识库内容。')}</p>
                </If>
            </div>
        </div>
    );
    if (isPracticeChannel) {
        if (isLoad) {
            return <Loading />;
        }
        if (isEmpty) {
            return (
                <div className="empty-practice-channel">
                    <div className="empty-practice-channel-text">{lang('暂无练习，请先创建练习。')}</div>
                    <a className="empty-practice-channel-add" href="/use#/practice" target="_blank">
                        {lang('去创建')}
                    </a>
                </div>
            );
        }
    }
    return isLoad ? <Loading /> : isEmpty ? EmptyData : '';
};
const columnsMap = {
    [SOURCE_DATA_TYPE.COURSE]: {
        columns: [
            {
                name: lang('课程信息'),
                width: '300px',
                dataIndex: 'title',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="course-info">
                            <Icon imgSrc={items.head_img || CustomImg.CourseDefault} className="icon-module" />
                            <Tooltip
                                title={items.title}
                                placement="bottom"
                                hideArrow
                                getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            >
                                <div
                                    className="truncate-text-2 course-title"
                                    onClick={() => {
                                        openWindow(items.share_url, '_blank');
                                    }}
                                >
                                    {items.title}
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                name: lang('创建者'),
                width: '200px',
                dataIndex: 'user_name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.username}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div
                                className={`truncate-text-2 course-title user-name ${
                                    items.is_read_only ? 'truncate-text-disabled' : ''
                                }`}
                                onClick={() => {
                                    const urls = `/platformManage/index#/user-detail?umu_id=${items.umu_id}`;
                                    !items.is_read_only && openWindow(urls, '_blank');
                                }}
                            >
                                {items.username}
                            </div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('创建时间'),
                width: '250px',
                dataIndex: 'ctime',
                className: 'project-cell',
                render: (items: IData) => {
                    return customFormatDateTime(Number(items.creat_time) * 1000, 'yyyy-MM-dd hh:mm');
                },
            },
        ],
        getDataFunc: getCourseList,
        searchParam: {
            is_course_in_lib: 1,
        },
    },
    [SOURCE_DATA_TYPE.PROGRAM]: {
        columns: [
            {
                name: lang('学习项目信息'),
                width: '250px',
                dataIndex: 'title',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="course-info">
                            <Icon imgSrc={items.head_img || CustomImg.ProgramDefault} className="icon-module" />
                            <Tooltip
                                title={items.program_title}
                                placement="bottom"
                                hideArrow
                                getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            >
                                <div
                                    className="truncate-text-2 course-title"
                                    onClick={() => {
                                        openWindow(items.share_url, '_blank');
                                    }}
                                >
                                    {items.program_title}
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                name: lang('创建者'),
                width: '200px',
                dataIndex: 'user_name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.username}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div
                                className={`truncate-text-2 course-title user-name ${
                                    items.is_read_only ? 'truncate-text-disabled' : ''
                                }`}
                                onClick={() => {
                                    const urls = `/platformManage/index#/user-detail?umu_id=${items.umu_id}`;
                                    !items.is_read_only && openWindow(urls, '_blank');
                                }}
                            >
                                {items.username}
                            </div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('内容数量'),
                width: '150px',
                dataIndex: 'content',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="program-info">
                            <span>{lang('学习阶段 {$0}', items.module_num)}</span>
                            <span>{lang('课程 {$0}', items.group_num)}</span>
                        </div>
                    );
                },
            },
            {
                name: lang('创建时间'),
                width: '200px',
                dataIndex: 'ctime',
                className: 'project-cell',
                render: (items: IData) => {
                    return customFormatDateTime(Number(items.ctime) * 1000, 'yyyy-MM-dd hh:mm');
                },
            },
        ],
        getDataFunc: getProgramList,
        searchParam: {
            // is_program_in_lib: 1,
        },
    },
    [SOURCE_DATA_TYPE.SESSION]: {
        columns: [
            {
                name: lang('小节信息'),
                width: '250px',
                dataIndex: 'title',
                className: 'project-cell',
                render: (items: IData) => {
                    const sessionName =
                        items.session_custom_type || items.type_name || SESSION_TYPE_NAMES[items.type] || lang('小节');
                    return (
                        <div className="session-info-msg">
                            <div className="resource-session-type">
                                <i className={getSessionIconClass(items.type)}></i>
                                <i className="resource-session-type-name" title={sessionName}>
                                    {sessionName}
                                </i>
                            </div>
                            <Tooltip
                                title={items.title}
                                placement="bottom"
                                hideArrow
                                getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            >
                                <div
                                    className="truncate-text-2 session-title"
                                    onClick={() => {
                                        openWindow(items.session_share_url, '_blank');
                                    }}
                                >
                                    {items.title}
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                name: lang('课程名称'),
                width: '200px',
                dataIndex: 'group_name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.group_name}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div
                                className="truncate-text-2 course-title group-name"
                                onClick={() => {
                                    if (items.group_share_url) {
                                        openWindow(items.group_share_url, '_blank');
                                    }
                                }}
                            >
                                {items.group_name}
                            </div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('创建者'),
                width: '200px',
                dataIndex: 'username',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.username}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div
                                className={`truncate-text-2 course-title user-name ${
                                    items.is_read_only ? 'truncate-text-disabled' : ''
                                }`}
                                onClick={() => {
                                    const urls = `/platformManage/index#/user-detail?umu_id=${items.umu_id}`;
                                    !items.is_read_only && openWindow(urls, '_blank');
                                }}
                            >
                                {items.username}
                            </div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('创建时间'),
                width: '200px',
                dataIndex: 'creat_time',
                className: 'project-cell',
                render: (items: IData) => {
                    return customFormatDateTime(Number(items.creat_time) * 1000, 'yyyy-MM-dd hh:mm');
                },
            },
        ],
        getDataFunc: getSessionList,
        searchParam: {
            is_course_in_lib: 1,
        },
    },
    [SOURCE_DATA_TYPE.LECTURER]: {
        columns: [
            {
                name: lang('讲师信息'),
                width: '250px',
                dataIndex: 'user_name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="course-info">
                            <UserAvatar src={items.avatar} className="icon-avatar" width={34} userLevelSize="M" />
                            <div
                                className={`truncate-text-2 course-title ${
                                    items.is_read_only ? 'truncate-text-disabled' : ''
                                }`}
                                onClick={() => !items.is_read_only && openWindow(items.share_url, '_blank')}
                            >
                                {items.user_name}
                            </div>
                        </div>
                    );
                },
            },
            {
                name: lang('创建课程数量'),
                width: '200px',
                textAlign: TextAlign.right,
                dataIndex: 'created_group_count',
                className: 'project-cell',
            },
            {
                name: lang('所属分组'),
                width: '150px',
                dataIndex: 'group',
                className: 'project-cell',
                render: (items: IData) => {
                    return items.enterprise_groups && items.enterprise_groups.length > 0 ? (
                        <Tooltip
                            placement="bottom"
                            hideArrow
                            title={
                                <div style={{ whiteSpace: 'pre-line', maxHeight: '180px', overflow: 'auto' }}>
                                    {items.enterprise_groups.join('\n')}
                                </div>
                            }
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <span className="truncate-text-2">{items.enterprise_groups.toString()}</span>
                        </Tooltip>
                    ) : (
                        ''
                    );
                },
            },
            {
                name: lang('所属部门'),
                width: '150px',
                dataIndex: 'depart',
                className: 'project-cell',
                render: (items: IData) => {
                    return items.enterprise_departments && items.enterprise_departments.length > 0 ? (
                        <Tooltip
                            placement="bottom"
                            hideArrow
                            title={
                                <span style={{ whiteSpace: 'pre-line', maxHeight: '180px' }}>
                                    {items.enterprise_departments.join('\n')}
                                </span>
                            }
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <span className="truncate-text-2">{items.enterprise_departments.toString()}</span>
                        </Tooltip>
                    ) : (
                        ''
                    );
                },
            },
        ],
        getDataFunc: getLecturerList,
        searchParam: {},
    },
    [SOURCE_DATA_TYPE.MICRO_PAGES]: {
        columns: [
            {
                name: lang('页面名称'),
                width: '200px',
                dataIndex: 'title',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.title}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div
                                className="truncate-text-2 course-title user-name"
                                onClick={() => {
                                    openWindow(items.share_url, '_blank');
                                }}
                            >
                                {items.title}
                            </div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('创建者'),
                width: '200px',
                dataIndex: 'user_name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.user_name}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div
                                className={`truncate-text-2 course-title user-name ${
                                    items.is_read_only ? 'truncate-text-disabled' : ''
                                }`}
                                onClick={() => {
                                    !items.is_read_only &&
                                        openWindow(
                                            `/platformManage/index#/user-detail?umu_id=${items.creator_id}`,
                                            '_blank',
                                        );
                                }}
                            >
                                {items.user_name}
                            </div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('权限'),
                width: '150px',
                dataIndex: 'access_permission',
                className: 'project-cell',
                render: (items: IData) => {
                    const permissions = accessPermissionMap[String(items.access_permission || 0)] || '';
                    const id = `${SOURCE_DATA_TYPE.MICRO_PAGES}-permissions-${items.id}`;
                    return permissions ? (
                        <Tooltip
                            title={
                                items.access_permission === '3' ? (
                                    <div id={id} className="micro-permissions-cell">
                                        {' '}
                                        <PermissionList data={items} portId={id} />
                                    </div>
                                ) : (
                                    permissions
                                )
                            }
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <span className="project-cell tags-cell">{permissions}</span>
                        </Tooltip>
                    ) : (
                        ''
                    );
                },
            },
            {
                name: lang('备注'),
                width: '300px',
                dataIndex: 'desc',
                className: 'project-cell',
                render: (items: IData) => {
                    return items.desc ? (
                        <Tooltip
                            title={items.desc}
                            placement="bottom"
                            hideArrow
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <span className="truncate-text-2">{items.desc}</span>
                        </Tooltip>
                    ) : (
                        ''
                    );
                },
            },
        ],
        getDataFunc: getMicroPagesList,
        searchParam: {},
    },

    [SOURCE_DATA_TYPE.PRACTICE_CHNNEL]: {
        columns: [
            {
                name: lang('练习频道名称'),
                width: '420px',
                dataIndex: 'name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="session-info-msg">
                            <Tooltip
                                title={items.name}
                                placement="bottom"
                                getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            >
                                <Button
                                    className="line-clamp-2 max-w-180 practice-name"
                                    type="link"
                                    href={items.url}
                                    target="_blank"
                                >
                                    {items.name}
                                </Button>
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                name: lang('权限'),
                width: '250px',
                dataIndex: 'access_permission',
                className: 'project-cell',
                render: (items: IData) => {
                    const permission = accessPermissionMap[String(items.access_permission || 0)] || '';
                    return (
                        <Tooltip
                            title={permission}
                            placement="bottom"
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div className={`truncate-text-2 practice-role`}>{permission}</div>
                        </Tooltip>
                    );
                },
            },
        ],
        getDataFunc: getPracticeChannelList,
        searchParam: {
            status: 1,
            source: 1,
        },
    },
    [SOURCE_DATA_TYPE.PRACTICE_OBJ]: {
        columns: [
            {
                name: lang('练习名称'),
                width: '150px',
                dataIndex: 'name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="session-info-msg w-150">
                            <Tooltip
                                title={items.name}
                                placement="bottom"
                                getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            >
                                <Button
                                    className="line-clamp-2 max-w-180 practice-name"
                                    type="link"
                                    href={items.url}
                                    target="_blank"
                                >
                                    {items.name}
                                </Button>
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                name: lang('练习类型'),
                width: '100px',
                dataIndex: 'obj_type',
                className: 'project-cell',
                render: (items: IData) => {
                    return <div className="session-info-msg">{practiceTypeName[items.obj_type as PRACTICE_TYPE]}</div>;
                },
            },
            {
                name: lang('所属频道名称'),
                width: '150px',
                dataIndex: 'channel_name',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <div className="session-info-msg">
                            <Tooltip
                                title={items.channel_name}
                                placement="bottom"
                                getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            >
                                <Button
                                    className="line-clamp-2 max-w-180 practice-name"
                                    type="link"
                                    href={items.channel_url}
                                    target="_blank"
                                >
                                    {items.channel_name}
                                </Button>
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                name: lang('练习描述'),
                width: '270px',
                dataIndex: 'desc',
                className: 'project-cell',
                render: (items: IData) => {
                    return (
                        <Tooltip
                            title={items.desc}
                            placement="bottom"
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                            overlayInnerStyle={{ maxHeight: 120, overflow: 'auto' }}
                        >
                            <div className="truncate-text-2 practice-desc">{items.desc}</div>
                        </Tooltip>
                    );
                },
            },
            {
                name: lang('权限'),
                width: '220px',
                dataIndex: 'access_permission',
                className: 'project-cell',
                render: (items: IData) => {
                    const permission = accessPermissionMap[String(items.access_permission || 0)] || '';
                    return (
                        <Tooltip
                            title={permission}
                            placement="bottom"
                            getTooltipContainer={() => document.getElementById(TABLE_ID) || document.body}
                        >
                            <div className={`truncate-text-2 practice-role`}>{permission}</div>
                        </Tooltip>
                    );
                },
            },
        ],
        getDataFunc: getCanRelationPracticeList,
        searchParam: {
            status: 1,
            source: 1,
        },
    },
    [SOURCE_DATA_TYPE.OUTER_URL]: {
        columns: [],
        searchParam: {},
    },
    [SOURCE_DATA_TYPE.CIRCLE]: {
        columns: [],
        searchParam: {},
    },
};

const getColumns = (info: {
    tabIndex: SOURCE_DATA_TYPE;
    isAllowRadio: boolean;
    selectList: ISourceInfo[];
    isHideOperate?: boolean;
    maxCount?: number;
    onSelectSource?: (items: IData, isRadio: boolean, isDel?: boolean) => void;
}) => {
    const {
        tabIndex: index,
        isAllowRadio,
        selectList = [],
        isHideOperate = false,
        maxCount = 1,
        onSelectSource: onSelect,
    } = info;
    const isMultiple = maxCount > 1;
    const newCol: any[] = [...columnsMap[index].columns];
    const key = index === SOURCE_DATA_TYPE.LECTURER ? 'umu_id' : 'id';
    const selectIds = selectList.filter((item) => item.option?.type === index).map((item) => item.option?.data?.[key]);
    if (isAllowRadio) {
        newCol.unshift({
            name: '',
            width: '44px',
            textAlign: TextAlign.center,
            dataIndex: 'index',
            className: 'project-cell',
            render: (items: IData) => {
                const isSelect = selectIds.includes(items[key]);
                const radioProps = {
                    data: {
                        label: '',
                        key: `${items.id}-${index}`,
                    },
                    onClick: (keys: string) => {
                        if (!isSelect && keys) {
                            onSelect && onSelect(items, true);
                        }
                    },
                    active: isSelect ? `${items.id}-${index}` : '',
                };
                return <RadioItem {...radioProps} />;
            },
        });
        return newCol;
    }
    if (!isHideOperate) {
        newCol.push({
            name: lang('操作'),
            width: getOperateWidth(),
            textAlign: TextAlign.center,
            dataIndex: 'operate',
            className: 'project-cell operate-cell',
            render: (items: IData) => {
                const isSelect = selectIds.includes(items[key]);
                if (isMultiple) {
                    const disabled = !isSelect && selectList.length >= maxCount;
                    return (
                        <Checkbox
                            checked={isSelect}
                            disabled={disabled}
                            onClick={() => disabled && SnackBar.show(lang('最多添加{$0{0=个,1=个}}内容', maxCount))}
                            onChange={() => onSelect && onSelect(items, false, isSelect)}
                        />
                    );
                }
                return (
                    <Button
                        type="text"
                        disabled={isSelect}
                        onClick={() => {
                            if (!isSelect) {
                                onSelect && onSelect(items, false);
                            }
                        }}
                    >
                        {isSelect ? lang('已选择') : lang('选择')}
                    </Button>
                );
            },
        });
        newCol[newCol.length - 1].fixed = FixedDirection.right;
    }
    newCol[0].fixed = FixedDirection.left;

    return newCol;
};

export { getBlank, getColumns, TABLE_ID, columnsMap };
